import React, {FC} from 'react';

import './styles.scss';

interface Props {
  videos: Array<{
    title: string;
    embed: string;
  }>;
}

const Videos: FC<Props> = ({videos}: Props) => {
  return (
    <section className="Videos">
      {videos?.map(({title, embed}) => (
        <article className="Videos__video" key={title}>
          <div className="Videos__embed" dangerouslySetInnerHTML={{__html: embed}} />
          <div className="Videos__meta">
            <h2 className="Videos__title" dangerouslySetInnerHTML={{__html: title}} />
          </div>
        </article>
      ))}
    </section>
  );
};

export default Videos;
